import React from "react";
import { HOTMART_URL } from "../../lib/constants";
import { AlertTriangle, Users, UserCheck, Coins, FileText, ArrowRight } from "lucide-react";

const FEATURES = [
  { icon: UserCheck, title: "Operação real em grua de comando", desc: "não num simulador" },
  { icon: Users, title: "Kawan contigo no campo", desc: "instrução personalizada" },
  { icon: Coins, title: "Desconto exclusivo de aluno", desc: "valor reduzido vs. preço público" },
  { icon: FileText, title: "Perfil profissional", desc: "preparado para começar" },
];

export default function PracticalClass() {
  return (
    <section
      className="relative py-24 sm:py-32 bg-zinc-950 border-b border-white/10 overflow-hidden"
      data-testid="practical-class-section"
    >
      {/* Warning stripes top */}
      <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-2 warning-stripes" />
      <div aria-hidden="true" className="absolute bottom-0 left-0 right-0 h-2 warning-stripes" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="inline-flex items-center gap-2 bg-red-600/15 border border-red-600/40 text-red-400 px-4 py-2 text-xs uppercase tracking-widest font-bold mb-8">
          <AlertTriangle className="w-4 h-4" />
          Opcional · Desconto de aluno · Vagas limitadas
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
              Aula Prática Presencial com Kawan Oliveira · 🏗 Aula Real em Obra
            </div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
              DO ECRÃ <br />
              <span className="text-yellow-400">PARA A OBRA.</span>
            </h2>
            <p className="mt-6 text-zinc-300 text-lg leading-relaxed">
              A teoria dá o certificado. <span className="text-white font-semibold">A prática dá o emprego.</span>
            </p>
            <p className="mt-4 text-zinc-400 max-w-xl leading-relaxed">
              Após concluíres a formação teórica online, desbloqueias uma oportunidade que não existe
              no mercado: <span className="text-white">aula prática presencial com o Kawan</span> numa
              grua <span className="text-white">de comando real</span> — com <span className="text-yellow-400 font-semibold">desconto exclusivo de aluno</span>,
              aplicado sobre o valor público da aula.
            </p>
            <p className="mt-3 text-zinc-500 text-sm max-w-xl leading-relaxed">
              <span className="text-zinc-300 font-semibold">Importante:</span> a aula prática é um serviço
              <span className="text-white"> separado e opcional</span>, não incluído no preço do curso online.
              Marcada sob disponibilidade de agenda do Kawan.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              {FEATURES.map((f) => (
                <div
                  key={f.title}
                  className="flex gap-3 p-4 border border-white/10 bg-black/40"
                >
                  <f.icon className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5" />
                  <div>
                    <div className="text-sm text-white font-semibold leading-tight">{f.title}</div>
                    <div className="text-xs text-zinc-500 mt-0.5">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="border border-red-600/40 bg-red-600/5 p-6 sm:p-8">
              <div className="flex items-start gap-3 mb-4">
                <AlertTriangle className="w-5 h-5 text-red-400 shrink-0 mt-1" />
                <div>
                  <div className="text-red-400 font-display text-xl uppercase leading-tight">
                    Serviço opcional · Paga-se à parte
                  </div>
                  <div className="text-zinc-400 text-sm mt-2">
                    Alunos do curso online têm <span className="text-yellow-400 font-semibold">desconto exclusivo</span>.
                    Marcação sob disponibilidade de agenda do Kawan. Máx. 4 alunos por turma.
                  </div>
                </div>
              </div>

              <a
                href={HOTMART_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="practical-cta-button"
                className="mt-4 group flex items-center justify-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-black font-display tracking-wide text-base sm:text-lg px-6 py-5 transition-colors w-full"
              >
                COMEÇAR PELO CURSO ONLINE
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
              </a>
              <p className="mt-3 text-[11px] text-zinc-500 uppercase tracking-widest text-center">
                Conclui a teoria · Desbloqueia o desconto na prática
              </p>

              <p className="mt-6 text-[11px] text-zinc-600 leading-relaxed">
                * A aula prática presencial é um serviço <span className="text-zinc-400">separado do curso online</span>,
                não incluído em nenhum dos pacotes. Após concluíres a formação teórica, o Kawan envia-te o
                valor com desconto de aluno e as datas disponíveis. Sujeito a disponibilidade.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
